import {Skeleton, Table, TableCell, TableHeading, Text} from "@nike/eds";
import React from "react";
import "./DashboardTable.css";

type DashboardTableProps = {
    isLoading: boolean;
    data
    tableTitle?: String;
    columnConfig: { header: string; accessor: string; formatNumber?: boolean; formatCurrency?: boolean }[];
};

const formatNumber = (value: number): string => {
    const locale = navigator.language;
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: 'decimal',
    }).format(value);
};

const formatCurrency = (value: number): string => {
    const locale = navigator.language;
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};

function DashboardTable(props: DashboardTableProps) {

    return (
        <div className="dashboardTable">
            <Table>
                <thead>
                <tr>
                    {props.tableTitle &&
                        <TableHeading colSpan={props.columnConfig.length}> <Text font={"title-5"}> {props.tableTitle} </Text></TableHeading>}

                </tr>
                <tr>
                    {props.columnConfig.map(column => (
                         (column.formatNumber || column.formatCurrency) ?
                        <TableHeading key={column.header} className={"rightFormattedCol"}>{column.header}</TableHeading>
                             :
                             <TableHeading key={column.header}>{column.header}</TableHeading>
                    ))}
                </tr>
                </thead>
                <tbody>
                {props.isLoading && (
                    <tr>
                        {props.columnConfig.map((_, index) => (
                            <TableCell key={index}><Skeleton height={35} width={"100%"}/></TableCell>
                        ))}
                    </tr>
                )}
                {!props.isLoading && props.data && props.data.map((dataItem, rowIndex) => (
                    <tr key={`row-${rowIndex}`} >
                        {props.columnConfig.map((column, cellIndex) => (
                            <TableCell key={`cell-${rowIndex}-${cellIndex}`} alignment={column.formatNumber || column.formatCurrency ? 'right' : 'left'}>
                                {column.accessor === 'yearMonth'
                                    ? `${dataItem.year}-${dataItem.month.padStart(2, "0")}`
                                    : column.formatNumber
                                        ? formatNumber(Number(dataItem[column.accessor]))
                                        : column.formatCurrency
                                            ? formatCurrency(Number(dataItem[column.accessor]))
                                            : dataItem[column.accessor]}
                            </TableCell>
                        ))}
                    </tr>
                ))}
                </tbody>
            </Table>
        </div>
    )
}

export {DashboardTable};